"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMousePointer = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M26.371 26.371l1.056-.358 5.283 5.283c.943.943-.471 2.357-1.414 1.414l-5.283-5.283-1.993 5.867c-.297.873-1.516.914-1.87.063l-7.07-16.97c-.344-.824.483-1.65 1.307-1.307l16.97 7.07c.851.354.81 1.573-.063 1.87l-5.867 1.993 5.283 5.283-1.414 1.414-5.283-5.283.358-1.056zm-3.393 3.773l1.658-4.883a1 1 0 01.625-.625l4.883-1.658L17.86 17.86l5.118 12.284z",
    id: "mouse-pointer_svg__a"
  }));
};

var _default = SvgMousePointer;
exports.default = _default;